// extracted by mini-css-extract-plugin
module.exports = {"component":"my-trip-webview_component__rDGkh"};